import { render } from "./ItemPokemon.vue?vue&type=template&id=204f2615"
import script from "./ItemPokemon.vue?vue&type=script&lang=js"
export * from "./ItemPokemon.vue?vue&type=script&lang=js"
script.render = render

export default script